export default __webpack_public_path__ + "static/media/mastercard-logo.7f5ebbfb.svg";